import { Injectable } from '@angular/core';

@Injectable()
export class PrimeiroAcesso {
    api: string;
    idEmpresa: string;
    email: string;
    documento: string;
    url: string;

    constructor() {
    }
}

export class PrimeiroAcessoResult {
  public primeiroAcesso: PrimeiroAcesso;
  public sucesso: boolean;
  public erros: Array<any>;
  public warnings: Array<any>;
  public token: string;
}
